import React, { useState } from 'react';
import './SimulatorForm.css';

const SimulatorForm = ({ onSubmit, onDemo, loading }) => {
  const [formData, setFormData] = useState({
    annual_income: 60000,
    monthly_expenses: {
      food: 500,
      housing: 1200,
      transportation: 350,
      healthcare: 250,
      utilities: 180,
      entertainment: 200,
      other: 300
    },
    savings: 15000,
    location: 'US'
  });

  const handleIncomeChange = (e) => {
    setFormData({
      ...formData,
      annual_income: parseFloat(e.target.value) || 0
    });
  };

  const handleExpenseChange = (category, value) => {
    setFormData({
      ...formData,
      monthly_expenses: {
        ...formData.monthly_expenses,
        [category]: parseFloat(value) || 0
      }
    });
  };

  const handleSavingsChange = (e) => {
    setFormData({
      ...formData,
      savings: parseFloat(e.target.value) || 0
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const totalMonthlyExpenses = Object.values(formData.monthly_expenses).reduce((a, b) => a + b, 0);
  const monthlyIncome = formData.annual_income / 12;
  const monthlySavings = monthlyIncome - totalMonthlyExpenses;

  return (
    <div className="simulator-form">
      <form onSubmit={handleSubmit}>
        {/* Income Section */}
        <div className="form-section">
          <h2>Income</h2>
          <div className="form-group">
            <label>Annual Income</label>
            <div className="input-with-prefix">
              <span className="prefix">$</span>
              <input
                type="number"
                value={formData.annual_income}
                onChange={handleIncomeChange}
                min="0"
                step="1000"
                required
              />
            </div>
            <small>Monthly: ${monthlyIncome.toFixed(0).toLocaleString()}</small>
          </div>
        </div>

        {/* Monthly Expenses Section - WITH FIELD ICONS */}
        <div className="form-section">
          <h2>Monthly Expenses</h2>
          <div className="expenses-grid">
            {Object.entries(formData.monthly_expenses).map(([category, value]) => {
              // Field icons mapping
              const icons = {
                food: '🍔',
                housing: '🏠',
                transportation: '🚗',
                healthcare: '⚕️',
                utilities: '⚡',
                entertainment: '🎬',
                other: '📦'
              };
              
              return (
                <div key={category} className="form-group">
                  <label>{icons[category]} {category.charAt(0).toUpperCase() + category.slice(1)}</label>
                  <div className="input-with-prefix">
                    <span className="prefix">$</span>
                    <input
                      type="number"
                      value={value}
                      onChange={(e) => handleExpenseChange(category, e.target.value)}
                      min="0"
                      step="10"
                      required
                    />
                  </div>
                </div>
              );
            })}
          </div>
          <div className="expense-summary">
            <strong>Total Monthly Expenses: ${totalMonthlyExpenses.toLocaleString()}</strong>
            <span className={monthlySavings >= 0 ? 'positive' : 'negative'}>
              Monthly Savings: ${monthlySavings.toLocaleString()}
            </span>
          </div>
        </div>

        {/* Savings Section */}
        <div className="form-section">
          <h2>Savings</h2>
          <div className="form-group">
            <label>Current Savings</label>
            <div className="input-with-prefix">
              <span className="prefix">$</span>
              <input
                type="number"
                value={formData.savings}
                onChange={handleSavingsChange}
                min="0"
                step="1000"
                required
              />
            </div>
          </div>
        </div>

        <button 
          type="submit" 
          className="submit-button"
          disabled={loading}
        >
          {loading ? '🔄 Running Simulation...' : '🚀 Run Inflation Simulation'}
        </button>
      </form>
    </div>
  );
};

export default SimulatorForm;
